import { useMutation } from "react-query";
import http from 'infra/http';

function useConfirmarAnuncio() {
  return useMutation(
    `/v1/anuncio/confirmar`,
    async (id: string) => {
      const { data } = await http.post<{success: boolean}>(
        `/v1/anuncio/${id}/aprovar`,
      );

      return data;
    },
    { retry: false }
  );
}

export default useConfirmarAnuncio;
